import DownloadIcon from "@mui/icons-material/Download";

const PDF_PATH = "/DataPulseTechnicalDocument.pdf";

const TechnicalGuidePage = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = PDF_PATH;
    link.download = "DataPulseTechnicalDocument.pdf";
    link.click();
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <div className="flex items-center justify-between px-6 py-3 bg-white border-b border-slate-200 shadow-sm">
        <span className="text-2xl font-semibold text-slate-800">
          DataPulse Technical Guide
        </span>
        <button
          onClick={handleDownload}
          className="flex items-center gap-1.5 px-4 py-2 bg-[#6366F1] text-white text-sm font-medium rounded-md transition-colors"
        >
          <DownloadIcon fontSize="small" />
          Download PDF
        </button>
      </div>
      <div className="flex-1 overflow-hidden">
        <iframe
          src={PDF_PATH}
          title="DataPulse Technical Guide"
          className="w-full h-full border-none"
        />
      </div>
    </div>
  );
};

export default TechnicalGuidePage;
